<div class="report-card">
  <div class="header">
    Work Hour Average
    <span class="sub-header">
      {{ startDate | date: 'shortDate' }} - {{ endDate | date: 'shortDate' }}
      @if (employee && !companyWide) {
        <span>, {{employee.fullName}}</span>
      }
      @if (companyWide) {
        <span>, All</span>
      }
    </span>
  </div>
  <app-loading-swirly [isLoading]="averageLoading"></app-loading-swirly>

  <canvas id="chartWorkJSContainer"></canvas>

  <canvas id="chartWellnessJSContainer"></canvas>
</div>
